<template>
  <div class="init">
    <div class="router-wrap">
      <div class="schoolPayIndex">
        <div class="company_list_container">
          <!-- 搜索 -->
          <div class="search_box">
            <form action="/">
              <van-search
                  v-model="value"
                  show-action
                  placeholder="请输入搜索关键词"
                  @search="onSearch"
                  @cancel="onCancel"
                  @input="onInput"
              />
            </form>
          </div>
          <div class="blank_box"></div>
          <!-- 学校列表 -->
          <div class="data_list_box">
            <div class="company_item bottom_line" @click="$router.push('/payInput?school_id='+item.school_id)" v-for="(item, index) in schoolList" :key="item.school_id">
              {{ item.name }}
            </div>
          </div>
          <!-- 没有列表时候提示 -->
          <div class="no_data" v-if="schoolList.length == 0">
            <van-empty image="search" description="暂无更多数据" />
          </div>
        </div>
        <div class="schoolPopup hidePopup"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { apiSchoolList } from "@/api/api"
export default {
  name: "schoolList",
  data() {
    return {
      value:'',       // 输入值
      isShow: true,
      schoolList:[],
      timer:null      // 防抖
    }
  },
  created() {
    this.getApiSchoolList()
  },
  methods:{
    getApiSchoolList(val){
      apiSchoolList({
        keyword:val,
        page:1,
        limit:10
      }).then(res=>{
        this.schoolList = res.data.data;
      })
    },
     // 去搜索
     onSearch(){

     },
    // 取消清楚文字
     onCancel(){
       this.value = ''
     },
    // 输入事件
     onInput(val){
      // 防抖处理
      if(this.timer){
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(()=>{
        this.getApiSchoolList(val)
      },500)
     }
   }

}
</script>

<style scoped lang="scss">
/deep/ .van-field__control{
  font-size: 3.73333vw;
  font-weight: 500;
}
/deep/ .van-search__content{
  background: #f4f4fb;
}
.init{
  .blank_box{
    height: 2.13333vw;
    background: #f4f4fb;
  }
  .data_list_box{
    text-align: left;
    padding-left: 4vw;
    background: #FFFFFF;
    .company_item{
      line-height: 5.33333vw;
      font-size: 3.73333vw;
      padding: 3.2vw 0 3.2vw 4.8vw;
      background: url(../../../static/images/scool/scoolList/school.png) 0 center no-repeat;
      background-size: 3.2vw 3.2vw;
      border-bottom: 1px solid #dddddd;
      font-weight: 600;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/schoolList/index.vue